import React from "react";

function Banner() {
  return (
    <header class="hero bg-content-hero-dark">
      <div class="content corner">
        <div class="d-flex flex-column">
          <div>
            <h1 class="mb-3 text-white">
              Infraestructura de Datos Espaciales de la Ciudad Autónoma de
              Buenos Aires IDECABA
            </h1>
            <p class="lead m-0 text-white">
              Accedé a los datos geoespaciales de la Ciudad de manera integrada
              y eficiente
            </p>
          </div>
        </div>
      </div>
      <div class="aside bg-aside-hero-dark"></div>
    </header>
  );
}

export default Banner;
